import { TaskPersonModel } from "./TaskPersonModel";
import { TaskPriorityModel } from "./TaskPriorityModel";
import { TaskStatusModel } from "./TaskStatusModel";
import { TaskTagModel } from "./TaskTagModel";
import { TaskTypeModel } from "./TaskTypeModel";

/**
 * * Модель группировки задач
 */
export class TasksKanbanGroupingModel {
  /**Группировка по статусу */
  Status?: TaskStatusModel;
  /**Группировка по приоритету */
  Priority?: TaskPriorityModel;
  /**Группировка по исполнителю */
  Performer?: TaskPersonModel;
  /**Группировка по автору */
  Author?: TaskPersonModel;
  /**Группировка по тегу */
  Tag?: TaskTagModel;
  /**Группировка по типу */
  Type?: TaskTypeModel;

  get IsEmpty() {
    return !this.Status && !this.Priority && !this.Performer && !this.Author;
  }

  constructor(obj?: Partial<TasksKanbanGroupingModel>) {
    Object.assign(this, obj);
  }
}
